import { AES, enc } from 'crypto-js';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Modal } from 'antd';
import {
  APP_KEY,
  CUSTOMER_APP_KEY,
  LANGUAGE,
  APP_DATE_FORMAT,
} from '../config';
import { getApiData } from '../hooks/useGetApi.hook';
import { getNCAProfileService } from '../services/NCA/CreateProfile/ncaCreateProfile.service';
import { routeObj } from '../services/Columns';
import store from '../redux/store';
import { resetGoogleMapState } from '../redux/slices/googlemap/googlemap.slice';
import {
  DATE_FULL_MONTH__DATE_TH_YEAR_TIME,
  DATE_MONTH_YEAR_TIME,
  GOOGLE_MAPS_API_KEY,
  STORE_APP_KEY,
} from '../config/app.config';
import { accessRegisterRoute } from '../routes/Auth/ncaRegisterSteps';
import { WEEK_START_FROM_DAY } from '../config';
import { useSelector } from 'react-redux';
import modalNotification from './notifications';

const getItem = (path, label, key, icon, children, submenu) => {
  if (children) {
    return { label, key, icon, children, path, submenu };
  }
  return { label, key, icon, path, submenu };
};

export const showDateInBrowser = (data) => {
  if (!data) return '-';
  // return moment(data).format('DD/MM/YYYY hh:mm A');
  try {
    return moment(data)
      .tz(moment.tz.guess())
      .format(DATE_FULL_MONTH__DATE_TH_YEAR_TIME);
  } catch (error) {
    return moment(data).format(DATE_MONTH_YEAR_TIME);
  }
};

export function formatPhoneNumber(phoneNumberString, code) {
  if (typeof phoneNumberString === 'string') {
    const phone = `${
      code ? (code?.includes('+') ? '(' + code + ')' : '(+' + code + ')') : ''
    } ${phoneNumberString?.slice(0, 3)}-${phoneNumberString?.slice(
      3,
      6
    )}-${phoneNumberString?.slice(6)}`;

    // let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    // let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    // if (match) {
    //   let intlCode = match[1] ? '+1 ' : '';
    //   return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    // }
    return phone || '';
  }

  // if (
  //   phoneNumberString &&
  //   phoneNumberString?.possibility != 'invalid-country-code'
  // ) {
  //   const splitNumber = phoneNumberString?.number?.international?.split(' ');
  //   let initCode = code;
  //   if (initCode && initCode[0] !== '+') {
  //     initCode = '+' + initCode;
  //   }
  //   return `(${initCode ?? splitNumber[0]}) ${splitNumber[1]}`;
  // } else if (phoneNumberString?.possibility === 'invalid-country-code') {
  //   let unknownNumber = phoneNumberString.number.input;
  //   if (unknownNumber.slice(0, 1) !== '+') {
  //     unknownNumber = '+' + unknownNumber;
  //   }
  //   const first2Char = unknownNumber.slice(0, 3);
  //   const phone = unknownNumber.slice(3);
  //   let phoneNumber = '';
  //   if (first2Char) {
  //     phoneNumber = `(${first2Char}) `;
  //   }
  //   phoneNumber = phoneNumber + phone;
  //   return phoneNumber;
  // }
  return '-';
}

export const phoneNumberFormate = (phoneNumberString, code) => {
  if (typeof phoneNumberString === 'string') {
    const phone = `${
      code ? (code?.includes('+') ? '(' + code + ')' : '(+' + code + ')') : ''
    } ${phoneNumberString ? phoneNumberString : '-'}`;
    return phone || '-';
  }
  return '-';
};
export const phoneNumberField = (e) => {
  let ASCIICode = e.which ? e.which : e.keyCode;
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
    e.preventDefault();
  }
};

export const getHeaderData = (arr) => {
  if (arr instanceof Array) {
    return arr.reduce((prev, item) => {
      if (item?.belongsToHeader) {
        if (item.children instanceof Array) {
          const children = item.children.reduce(
            (prevElement, currentSubChild) => {
              if (currentSubChild?.belongsToHeader) {
                prevElement.push(
                  getItem(
                    currentSubChild?.path,
                    currentSubChild?.name,
                    currentSubChild?.key,
                    currentSubChild?.icon,
                    ''
                  )
                );
              }
              return prevElement;
            },
            []
          );
          prev.push(
            getItem(item?.path, item?.name, item?.key, item?.icon, children)
          );
        } else {
          prev.push(getItem(item?.path, item?.name, item?.key, item?.icon));
        }
      }
      return prev;
    }, []);
  }
  return [];
};

export const getFooterLink = (arr) => {
  if (arr instanceof Array) {
    return arr.reduce((prev, item) => {
      if (item?.belongsToFooter) {
        if (item.children instanceof Array) {
          const children = item.children.reduce(
            (prevElement, currentSubChild) => {
              if (currentSubChild?.belongsToFooter) {
                prevElement.push(
                  getItem(
                    currentSubChild?.path,
                    currentSubChild?.name,
                    currentSubChild?.key,
                    currentSubChild?.icon,
                    ''
                  )
                );
              }
              return prevElement;
            },
            []
          );
          prev.push(
            getItem(item?.path, item?.name, item?.key, item?.icon, children)
          );
        } else {
          prev.push(getItem(item?.path, item?.name, item?.key, item?.icon));
        }
      }
      return prev;
    }, []);
  }
  return [];
};

export const removeSessionStorageToken = () => {
  if (sessionStorage.getItem(`${APP_KEY}:token`)) {
    sessionStorage.setItem(`${APP_KEY}:token`, null);
  }
};

export const setSessionStorageToken = (token) => {
  sessionStorage.setItem(
    `${APP_KEY}:token`,
    AES.encrypt(token, `${APP_KEY}-token`).toString()
  );
};

export const encryptValue = (
  data
  // userId
) => {
  return AES.encrypt(data).toString();
};

export const decryptValue = (
  data
  // userId
) => {
  return AES.encrypt(data).toString();
};

export const removeLocalStorageToken = (navigate, userRole) => {
  if (userRole === 'customer') {
    if (localStorage.getItem(`${CUSTOMER_APP_KEY}:token`)) {
      localStorage.setItem(`${CUSTOMER_APP_KEY}:token`, null);
    }
  } else if (userRole === 'store') {
    if (localStorage.getItem(`${STORE_APP_KEY}:token`)) {
      localStorage.setItem(`${STORE_APP_KEY}:token`, null);
    }
  } else {
    if (localStorage.getItem(`${APP_KEY}:token`)) {
      localStorage.setItem(`${APP_KEY}:token`, null);
    }
  }

  store.dispatch(resetGoogleMapState());
  if (navigate) {
    navigate('/');
  }
};

export const getSessionStorageToken = () => {
  const ciphertext = sessionStorage.getItem(`${APP_KEY}:token`);
  if (ciphertext) {
    const bytes = AES.decrypt(ciphertext, `${APP_KEY}-token`);
    return bytes.toString(enc.Utf8);
  }
  return false;
};

export const setLocalStorageToken = (token, userRole) => {
  localStorage.setItem(
    `${
      userRole === 'customer'
        ? CUSTOMER_APP_KEY
        : userRole === 'store'
        ? STORE_APP_KEY
        : APP_KEY
    }:token`,
    AES.encrypt(
      token,
      `${
        userRole === 'customer'
          ? CUSTOMER_APP_KEY
          : userRole === 'store'
          ? STORE_APP_KEY
          : APP_KEY
      }-token`
    ).toString()
  );
};

export const getLocalStorageToken = (role) => {
  const token = localStorage.getItem(`${APP_KEY}:token`);
  const customerToken = localStorage.getItem(`${CUSTOMER_APP_KEY}:token`);
  const storeToken = localStorage.getItem(`${STORE_APP_KEY}:token`);

  if (role === 'customer') {
    if (customerToken) {
      const bytes = AES.decrypt(customerToken, `${CUSTOMER_APP_KEY}-token`);
      return bytes?.toString(enc.Utf8);
    }
  } else if (role === 'store') {
    if (storeToken) {
      const bytes = AES.decrypt(storeToken, `${STORE_APP_KEY}-token`);
      return bytes?.toString(enc.Utf8);
    }
  } else {
    if (token) {
      const bytes = AES.decrypt(token, `${APP_KEY}-token`);
      return bytes?.toString(enc.Utf8);
    }
  }

  return false;
};

export const getLocalStorageLanguage = () => {
  const language = localStorage.getItem(`${APP_KEY}:language`);
  if (language) {
    return ['en', 'hi'].includes(language) ? language : LANGUAGE;
  }
  return LANGUAGE;
};

export const getCompleteUrl = (url) => {
  return url;
};

export function decodeQueryData(data) {
  return JSON.parse(
    `{"${decodeURI(data)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/%2F/g, '/')
      .replace(/%26/g, '&')
      .replace(/%2C/g, ',')
      .replace(/\+/g, ' ')
      .replace('?', '')}"}`
  );
}

export const navigateWithParam = (data, navigate, pathname, newTab) => {
  const searchParams = new URLSearchParams(data).toString();

  navigate(`${pathname}?${searchParams}`);
  if (newTab) {
    openInNewTab(`${pathname}?${searchParams}`);
  }
};

export function getSortType(data) {
  return data === 'ASC' ? 'asc' : 'desc';
}

export function dateFormatter(params, format) {
  if (params === null) {
    return '-';
  }

  return moment(
    new Date(params).toLocaleString('en-US', {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
  ).format(format ?? APP_DATE_FORMAT);
}

export function filterDateFormatter(param, format) {
  return moment(param).format(format);
}

export function momentDateFormatter(param, format) {
  return moment(param, format);
}

function openModal(text, heading, extraClass = '') {
  Modal.info({
    title: heading,
    centered: true,
    content: <div className={extraClass}>{text}</div>,
    onOk() {},
  });
}

export function readMoreTextShow(data, heading, length = 30, isLine, extraClass) {
  if ([undefined, null, false].includes(data)) {
    return <></>;
  }
  if (Array.isArray(data)) {
    if (data.join(', ').length < length) {
      return <>{data}</>;
    }
  } else if (data.length < length) {
    return <>{data || '-'}</>;
  }

  return isLine ? (
    <>
      {Array.isArray(data)
        ? data.join(', ').substring(0, length)
        : data.substring(0, length)}
      ...
      <Link
        to="/"
        onClick={(e) => {
          e.preventDefault();
          openModal(data, heading, extraClass);
        }}
        style={{ fontWeight: '900' }}
      >
        Read More
      </Link>
    </>
  ) : (
    <p className="mb-0">
      {Array.isArray(data)
        ? data.join(', ').substring(0, length)
        : data.substring(0, length)}
      ...
      <Link
        to="/"
        onClick={(e) => {
          e.preventDefault();
          openModal(data, heading, extraClass);
        }}
      >
        Read More
      </Link>
    </p>
  );
}

export function readMoreTextShowArray(
  data,
  heading,
  length = 3,
  extraClass = ''
) {
  if (data.length < length) {
    return <>{data}</>;
  }
  return (
    <p className="mb-0">
      {data.slice(0, length)}
      <Link
        to="/"
        className="text-mute f-12"
        onClick={(e) => {
          e.preventDefault();
          openModal(data, heading, extraClass);
        }}
      >
        Read More
      </Link>
    </p>
  );
}

export function removeDuplicates(arr, key, isTag = true, objKey = 'id') {
  const unique = arr?.filter((obj, index) => {
    if (isTag && isTag !== 'no') {
      return (
        index ===
        arr?.findIndex((o) => obj?.tag === o?.tag && o?.tagType === key)
      );
    } else if (isTag === 'no') {
      return (
        index ===
        arr?.findIndex((o) => parseInt(obj?.[objKey]) === parseInt(o?.[objKey]))
      );
    }
  });
  return unique;
}

export function viewMoreTagShowArray(
  data,
  heading,
  length = 3,
  extraClass = ''
) {
  if (data.length < length) {
    return <>{data}</>;
  }
  return (
    <p className="mb-0">
      {data.slice(0, length)}
      <Link
        to="/"
        className="text-mute f-12"
        onClick={(e) => {
          e.preventDefault();
          openModal(data, heading, extraClass);
        }}
      >
        {data?.length > 3 && <>View More</>}
      </Link>
    </p>
  );
}

export function PhoneNumber({ countryCode, contactNumber }) {
  if (countryCode && contactNumber) {
    return <>{`${countryCode}-${contactNumber}`}</>;
  }
  return <span className="center">-</span>;
}

export function otpRegex() {
  let regex = /^[0-9]+$/;
  return regex;
}

export function phoneRegex() {
  let regex =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  return regex;
}

export function getSideBarData(arr) {
  if (arr instanceof Array) {
    return arr.reduce((prev, item) => {
      if (item?.belongsToSidebar) {
        if (item.children instanceof Array) {
          const children = item.children.reduce(
            (prevElement, currentSubChild) => {
              if (currentSubChild?.belongsToSidebar) {
                prevElement.push(
                  getItem(
                    currentSubChild?.path,
                    currentSubChild?.name,
                    currentSubChild?.key,
                    currentSubChild?.icon,
                    '',
                    currentSubChild?.submenu
                  )
                );
              }
              return prevElement;
            },
            []
          );
          prev.push(
            getItem(
              item?.path,
              item?.name,
              item?.key,
              item?.icon,
              children,
              item.submenu
            )
          );
        } else {
          prev.push(
            getItem(item?.path, item?.name, item?.key, item?.icon, item.submenu)
          );
        }
      }
      return prev;
    }, []);
  }
  return [];
}

export function backToPage(navigate, redirectUrl) {
  navigate(redirectUrl);
}

export function closeToPage() {
  window.close();
}

// Download document/file
export const downloadFile = (url) => {
  let link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  // link.download = extractFileName(url);
  link.dispatchEvent(new MouseEvent('click'));
};

export const disabledPastDate = (current) => {
  return moment().add(-1, 'days') >= current;
};

export const disabledEndDate = (current, startDate = moment()) => {
  return current && current < moment(startDate, 'YYYY-MM-DD');
};

export const disabledFutureDate = (current) => {
  return current > moment();
};
export const disabledPastAndFutureDate = (current, startDate = moment()) => {
  return (
    (current && current < moment(startDate, 'YYYY-MM-DD')) || current > moment()
  );
};

export const idConvertIntoArray = (idString) => {
  if (idString) return idString.split(',').map((e) => parseInt(e));
};

export const getTagId = (tagData, type) => {
  return tagData
    .filter((item) => item?.Tag?.tagType === type)
    .map((id) => id?.tagId);
};

// Create one d Object from 2d object
// export const getApiDetailsObj = (data) => {
//   if (data && data.length) {
//     let dataObj = {};
//     data.forEach((e) => {
//       dataObj = {
//         ...dataObj,
//         [e.key]: e.value,
//       };
//       if (e?.imageUrl) {
//         dataObj[`${e.key}_url`] = e.imageUrl;
//       }
//     });
//     return dataObj;
//   }
// };

export const getApiDetailsObj = (data, defaultKey) => {
  if (data && data.length) {
    let dataObj = {};
    data.forEach((e) => {
      if (
        (defaultKey === 'ReportAnIssue' || 'shoppingCart' || 'VoiceAI') &&
        e?.GeneralSettingValues?.length > 0
      ) {
        dataObj = {
          ...dataObj,
          [e?.key]: e?.GeneralSettingValues.length
            ? e?.GeneralSettingValues?.map((z) => z?.value)
            : [],
        };
      } else {
        dataObj = {
          ...dataObj,
          [e?.key]: e.value,
        };
      }
      if (e?.imageUrl) {
        dataObj[`${e?.key}_url`] = e.imageUrl;
      }
    });
    return dataObj;
  }
};

export const getApiDetailsObjNCA = (data, defaultKey) => {
  if (data && data.length) {
    let dataObj = {};
    if (defaultKey === 'ReportAnIssue') {
      let damagedEquipment =
        data?.length &&
        data.filter(
          (e) => e?.NcaGeneralSettingKey?.key === 'damaged_equipment_issue'
        ) &&
        data.filter(
          (e) => e?.NcaGeneralSettingKey?.key === 'damaged_equipment_issue'
        )?.length
          ? data
              .filter(
                (e) =>
                  e?.NcaGeneralSettingKey?.key === 'damaged_equipment_issue'
              )
              ?.map((z) => z?.value)
          : [];

      let paymentIssue =
        data?.length &&
        data.filter((e) => e?.NcaGeneralSettingKey?.key === 'payment_issue') &&
        data.filter((e) => e?.NcaGeneralSettingKey?.key === 'payment_issue')
          ?.length
          ? data
              .filter((e) => e?.NcaGeneralSettingKey?.key === 'payment_issue')
              ?.map((z) => z?.value)
          : [];

      let appIssues =
        data?.length &&
        data.filter((e) => e?.NcaGeneralSettingKey?.key === 'app_issues') &&
        data.filter((e) => e?.NcaGeneralSettingKey?.key === 'app_issues')
          ?.length
          ? data
              .filter((e) => e?.NcaGeneralSettingKey?.key === 'app_issues')
              ?.map((z) => z?.value)
          : [];

      let otherIssue =
        data?.length &&
        data.filter((e) => e?.NcaGeneralSettingKey?.key === 'other_issue') &&
        data.filter((e) => e?.NcaGeneralSettingKey?.key === 'other_issue')
          ?.length
          ? data
              .filter((e) => e?.NcaGeneralSettingKey?.key === 'other_issue')
              ?.map((z) => z?.value)
          : [];

      let supplyHouse =
        data?.length &&
        data.filter(
          (e) => e?.NcaGeneralSettingKey?.key === 'supply_house_issue'
        ) &&
        data.filter(
          (e) => e?.NcaGeneralSettingKey?.key === 'supply_house_issue'
        )?.length
          ? data
              .filter(
                (e) => e?.NcaGeneralSettingKey?.key === 'supply_house_issue'
              )
              ?.map((z) => z?.value)
          : [];
      dataObj = {
        damaged_equipment_issue: damagedEquipment,
        payment_issue: paymentIssue,
        app_issues: appIssues,
        other_issue: otherIssue,
        supply_house_issue: supplyHouse,
      };
    } else if (defaultKey === 'shoppingCart') {
      let shippingEmailAddress =
      data?.length &&
      data.filter(
        (e) => e?.NcaGeneralSettingKey?.key === 'shipping_email_address'
      ) &&
      data.filter(
        (e) => e?.NcaGeneralSettingKey?.key === 'shipping_email_address'
      )?.length
        ? data
            .filter(
              (e) =>
                e?.NcaGeneralSettingKey?.key === 'shipping_email_address'
            )
            ?.map((z) => z?.value)
        : [];

        let shippingRate = data
          ?.filter((e) =>
            e?.NcaGeneralSettingKey?.key === 'shipping_rate'
          )[0]?.value || '';
        
        dataObj = {
          shipping_rate: shippingRate,
          shipping_email_address: shippingEmailAddress,
        };
    } else if (defaultKey === 'VoiceAI') {
      let voiceAiEmailAddress = 
      data?.length &&
      data.filter(
        (e) => e?.NcaGeneralSettingKey?.key === 'lex_email_address'
      ) &&
      data.filter(
        (e) => e?.NcaGeneralSettingKey?.key === 'lex_email_address'
      )?.length
        ? data
            .filter(
              (e) =>
                e?.NcaGeneralSettingKey?.key === 'lex_email_address'
            )
            ?.map((z) => z?.value)
        : [];

        let phoneNumber = data
          ?.filter((e) =>
            e?.NcaGeneralSettingKey?.key === 'phone_number'
          )[0]?.value || '';
        
        dataObj = {
          phone_number: phoneNumber,
          lex_email_address: voiceAiEmailAddress,
        };
    } else {
      data.forEach((e) => {
        dataObj = {
          ...dataObj,
          [e?.NcaGeneralSettingKey?.key]: e.value,
        };
        if (e?.imageUrl) {
          dataObj[`${e?.key}_url`] = e.imageUrl;
        }
      });
    }
    return dataObj;
  }
};

// For make one d object from two d oject

export const getOneDObj = (data) => {
  if (data) {
    let arrayObj = Object.keys(data);
    let oneDObj = {};
    arrayObj.forEach((item) => {
      if (typeof data[item] === 'object') {
        oneDObj = {
          ...oneDObj,
          ...data[item],
        };
      }
    });
    let arrayOneDObj = Object.keys(oneDObj);
    arrayOneDObj.forEach((item) => {
      if (typeof oneDObj[item] === 'object') {
        oneDObj = {
          ...oneDObj,
          ...oneDObj[item],
        };
      }
    });
    return { ...data, ...oneDObj };
  }
};
// Disabled date for date picker
export const disabledDateWithYear = ({ year }) => {
  return moment().subtract(year, 'years');
};

export const momentTimeFormatter = (param) => {
  return moment(param);
};

export const agoDateTime = (addHour, addType, format, date = '') => {
  let getCurrentTime = momentTimeFormatter(date || new Date());
  return getCurrentTime.add(addHour, addType).format(format);
};

export const disabledPastTime = (date) => {
  let hours = [];
  const currentDate = new Date();
  if (dateFormatter(currentDate, 'YYYY-MM-DD') === date) {
    [...new Array(60)].forEach((item, key) => {
      if (key < dateFormatter(currentDate, 'HH')) {
        hours.push(key);
      }
    });
  }

  return {
    disabledHours: () => hours,
    disabledMinutes: (selectedHour) => {
      let disabled = [];
      if (
        dateFormatter(currentDate, 'YYYY-MM-DD') === date &&
        selectedHour === Number(dateFormatter(currentDate, 'HH'))
      ) {
        [...new Array(60)].forEach((item, key) => {
          if (key < dateFormatter(currentDate, 'mm')) {
            disabled.push(key);
          }
        });
      }
      return disabled;
    },
  };
};
// add and remove id into array
export const addRemoveID = ({ checked, id, arr }) => {
  if (checked) {
    arr.push(id);
  } else {
    let index = arr.indexOf(id);
    arr.splice(index, 1);
  }
  return arr;
};
// Expire Year
export const expireYearList = (year = 10) => {
  let yearList = [];
  let obj = {};
  let array = [...Array(year).keys()];
  let currentYear = new Date().getFullYear();
  array.forEach((item, index) => {
    obj = {
      name: currentYear + index,
      value: currentYear + index,
    };
    yearList.push(obj);
  });
  return yearList;
};

// Local storage
export const setLocalStorage = ({ keyName, data }) => {
  let stringData = JSON.stringify(data);
  localStorage.setItem(
    `${APP_KEY}:${keyName}`,
    AES.encrypt(stringData, `${APP_KEY}-${keyName}`).toString()
  );
};

export const getLocalStorage = ({ keyName }) => {
  const cipherText = localStorage.getItem(`${APP_KEY}:${keyName}`);
  if (cipherText) {
    const bytes = AES.decrypt(cipherText, `${APP_KEY}-${keyName}`);
    return JSON.parse(bytes.toString(enc.Utf8));
  }
  return false;
};

export const removeLocalStorage = (keyName) => {
  if (localStorage.getItem(`${APP_KEY}:${keyName}`)) {
    localStorage.setItem(`${APP_KEY}:${keyName}`, '');
  }
};

// Redirect and check profile step completed or not
const routeObjData = routeObj();
export const ncaProfileRedirect = async (navigate, skipStep = false) => {
  let getData = await getApiData({
    service: getNCAProfileService,
  });
  if (getData && getData?.CompanyNca?.isPlanCancelled === 1) {
    navigate(accessRegisterRoute.CANCEL_COMPANY_PROFILE.path);
  } else if (getData && getData?.CompanyNca?.onBoardingStep) {
    if (getData?.CompanyNca?.onBoardingStep === 3 && skipStep) {
      return;
    }
    navigate(routeObjData[getData?.CompanyNca?.onBoardingStep]);
  }
};

export const updateTableData = (data, row, status, statusKey) => {
  // data = array list
  // row = selected row
  // status = current status user selected
  // statusKey =  key that belongs to toggle
  const index = data.length && data.findIndex((e) => e.id === row.id);
  data[index] = { ...data[index], [statusKey]: status };
  return data;
};

// For Number key Scroll

export function handleKey(e) {
  let ASCIICode = e.keyCode;
  if (
    ASCIICode === 37 ||
    ASCIICode === 38 ||
    ASCIICode === 39 ||
    ASCIICode === 40 ||
    ASCIICode === 69
  ) {
    e.preventDefault();
  }
}

export function upperCaseHandler(str) {
  let data = str?.charAt(0)?.toUpperCase() + str?.slice(1);
  return data;
}

export function checkValidImages({ url }) {
  let updatedUrl = url.split(/[?#]/)[0];
  let res = updatedUrl && updatedUrl.match(/\.(jpeg|jpg|gif|png)$/) != null;
  return res;
}

export const placeholderFormatter = (t, place) => {
  return `${t('text.data.enter')} ${t(`text.data.${place}`)}`;
};
export const capitalizeFirstLetter = (string) => {
  return (
    typeof string === 'string' &&
    string?.charAt(0).toUpperCase() + string.slice(1)
  );
};

export const acceptMediaFiles = [
  '.png',
  '.pdf',
  '.docx',
  '.jpg',
  '.jpeg',
  '.mp4',
  '.mp3',
];

export const acceptChatMediaFiles = ['png', 'jpg', 'jpeg', 'gif', 'mp4', 'mov'];

export const abortController = (() => {
  let controller = new AbortController();
  let signal = controller.signal;

  const abortPendingRequest = () => {
    controller.abort();
    controller = new AbortController();
    signal = controller.signal;
  };

  const getSignalToken = () => signal;

  return {
    abortPendingRequest,
    getSignalToken,
  };
})();

export const openInNewTab = (url) => {
  try {
    if (url) {
      window.open(url);
    }
    return true;
  } catch (err) {
    console.log(err);
  }
};

export const userRoleCheck = (data) => {
  let role = '';

  if (
    (data?.name === 'admin' && data?.type === 'admin') ||
    data?.type === 'nca'
  ) {
    role = 'admin';
  } else if (data?.name === 'customer' && data?.type === 'public') {
    role = 'customer';
  } else if (data?.name === 'store' && data?.type === 'public') {
    role = 'store';
  }
  return role;
};

export const generateStarRating = (
  rating,
  isDecimal = true,
  classes = {
    defaultIconClass: '',
    halfStarClass: '',
    fullStarClass: '',
    outlineStarClass: '',
  }
) => {
  const ratingArray = [1, 2, 3, 4, 5];
  let defaultIconClass =
    classes?.defaultIconClass || 'info_icon info_icon-gray';
  let halfStarClass = classes?.halfStarClass || 'gg-half-star';
  let fullStarClass = classes?.fullStarClass || 'gg-full-star';
  let outlineStarClass = classes?.outlineStarClass || 'gg-star-outline';

  return (
    <>
      {isDecimal ? (
        <i data-star={rating}></i>
      ) : (
        ratingArray.map((star, idx) => (
          <li key={idx}>
            <em
              className={`${defaultIconClass} ${
                star <= Math.ceil(rating)
                  ? rating % 1 !== 0 && Math.ceil(rating) === star
                    ? halfStarClass
                    : fullStarClass
                  : outlineStarClass
              }   `}
            />
          </li>
        ))
      )}
    </>
  );
};

export const sortingCompare = (array) => {
  return array.sort((a, b) => {
    if (a > b) return -1;
    if (a < b) return 1;
    return 0;
  });
};

export const arrayEqual = (idArray, getQuoteId) => {
  return (
    Array.isArray(idArray) &&
    Array.isArray(getQuoteId) &&
    idArray?.length === getQuoteId?.length &&
    sortingCompare(idArray).every(
      (val, index) => val === sortingCompare(getQuoteId)[index]
    )
  );
};

export const getAddressByGeoCode = async ({ lat, lng, apiKey }) => {
  const GOOGLE_API = 'https://maps.googleapis.com/maps/api/geocode/json';

  if (!lat || !lng) {
    return Promise.reject(new Error('Provided coordinates are invalid'));
  }
  const latLng = `${lat},${lng}`;
  let url = `${GOOGLE_API}?latlng=${encodeURIComponent(latLng)}`;

  url += `&key=${apiKey || GOOGLE_MAPS_API_KEY}`;

  const response = await fetch(url).catch(() =>
    Promise.reject(new Error('Error fetching data'))
  );

  const json = await response.json().catch(() => {
    return Promise.reject(new Error('Error parsing server response'));
  });

  if (json.status === 'OK') {
    return json;
  }

  return Promise.reject(
    new Error(
      `${json.error_message}.\nServer returned status code ${json.status}`
    )
  );
};

export const months = [
  { id: 1, month: 'Jan' },
  { id: 2, month: 'Feb' },
  { id: 3, month: 'Mar' },
  { id: 4, month: 'Apr' },
  { id: 5, month: 'May' },
  { id: 6, month: 'June' },
  { id: 7, month: 'July' },
  { id: 8, month: 'Aug' },
  { id: 9, month: 'Sep' },
  { id: 10, month: 'Oct' },
  { id: 11, month: 'Nov' },
  { id: 12, month: 'Dec' },
];

export const monthConverter = (monthNumber = []) => {
  const date = new Date();
  return (
    monthNumber.length &&
    monthNumber.map((v) => {
      date.setMonth(v - 1);
      return date.toLocaleString('en-US', {
        month: 'long',
      });
    })
  );
};

export const getDayNumberFromDate = (date) => {
  var d = new Date(date);
  var dayNumber = d.getDay();
  return dayNumber;
};

export const getAutoFromAndToDate = (defaultKey) => {
  let todayDate = new Date();
  if (defaultKey) {
    if (defaultKey === 'today') {
      let data = {
        dateType: 'today',
        fromDate: dateFormatter(todayDate, 'YYYY-MM-DD'),
        toDate: dateFormatter(todayDate, 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'yesterday') {
      let data = {
        dateType: 'yesterday',
        fromDate: dateFormatter(moment().subtract(1, 'days'), 'YYYY-MM-DD'),
        toDate: dateFormatter(moment().subtract(1, 'days'), 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'currentWeek') {
      let startOfWeek = moment()
        .startOf('week')
        .add(WEEK_START_FROM_DAY, 'days');
      let endOfWeek = moment().endOf('week').add(WEEK_START_FROM_DAY, 'days');
      let data = {
        dateType: 'currentWeek',
        fromDate: dateFormatter(startOfWeek, 'YYYY-MM-DD'),
        toDate: dateFormatter(endOfWeek, 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'previousWeek') {
      let prev = moment()
        .startOf('week')
        .subtract(1, 'weeks')
        .add(WEEK_START_FROM_DAY, 'days');
      let end = moment()
        .startOf('week')
        .subtract(1, 'days')
        .add(WEEK_START_FROM_DAY, 'days');

      let data = {
        dateType: 'previousWeek',
        fromDate: dateFormatter(prev, 'YYYY-MM-DD'),
        toDate: dateFormatter(end, 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'currentMonth') {
      let prev = moment().startOf('month');
      let end = moment().endOf('month');

      let data = {
        dateType: 'currentMonth',
        fromDate: dateFormatter(prev, 'YYYY-MM-DD'),
        toDate: dateFormatter(end, 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'previousMonth') {
      let prev = moment().startOf('month').subtract(1, 'month');
      let end = moment().startOf('month').subtract(1, 'days');

      let data = {
        dateType: 'previousMonth',
        fromDate: dateFormatter(prev, 'YYYY-MM-DD'),
        toDate: dateFormatter(end, 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'currentYear') {
      let prev = moment().startOf('year');
      let end = moment().endOf('year');

      let data = {
        dateType: 'currentYear',
        fromDate: dateFormatter(prev, 'YYYY-MM-DD'),
        toDate: dateFormatter(end, 'YYYY-MM-DD'),
      };
      return data;
    }
    if (defaultKey === 'previousYear') {
      let prev = moment().startOf('year').subtract(1, 'year');
      let end = moment().startOf('year').subtract(1, 'days');

      let data = {
        dateType: 'previousYear',
        fromDate: dateFormatter(prev, 'YYYY-MM-DD'),
        toDate: dateFormatter(end, 'YYYY-MM-DD'),
      };
      return data;
    }
  }
};
export const startTimer = (distance) => {
  let data = '';
  if (distance) {
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (hours > 0) {
      data += `${hours}h `;
    }
    if (minutes > 0) {
      data += `${minutes}m `;
    }
    if (seconds > 0) {
      data += `${seconds}s `;
    }
  }
  return data;
};
export const minutesToTime = (my_minutes, isAll = true, isMinute = true) => {
  const secs = isMinute ? my_minutes * 60 : my_minutes;
  const hours = Math.floor(secs / (60 * 60));

  const divisor_for_minutes = secs % (60 * 60);
  const minutes = Math.floor(divisor_for_minutes / 60);

  const divisor_for_seconds = divisor_for_minutes % 60;
  const seconds = Math.ceil(divisor_for_seconds);

  // const obj = {
  //   h: hours,
  //   m: minutes,
  //   s: seconds,
  // };
  let result = '';

  if (isAll) {
    result = `${hours}h ${minutes}m ${seconds}s`;
  } else {
    if (hours > 0) result = hours + 'h';
    if (minutes > 0) result = result + ` ${minutes}m`;
    if (seconds > 0) result = result + ` ${seconds}s`;
    result = result.trim();
  }

  return result;
};

export function secondsToHms(d) {
  d = Number(d);
  if (d > 0) {
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);
    let result = `${h}h ${m}m ${s}s`;
    return result;
  } else {
    let result = `${d}h ${d}m ${d}s`;
    return result;
  }
}

export const getFilterListData = (value) => {
  return value.map((item) => ({
    name: `${item?.firstName} ${item?.lastName} ${
      item?.email ? `-(${item?.email})` : ''
    }`,
    id: item?.id,
  }));
};

export const handlePrint = (divId, userType) => {
  let printContents = document.getElementById(divId).innerHTML;

  var winPrint = window.open(
    '',
    '_blank',
    'left=0,top=0,width=1000,height=800,toolbar=0,scrollbars=0,status=0'
  );
  if (userType === 'admin') {
    // winPrint.document.write(
    //   '<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet"><style>@media print{body{-webkit-print-color-adjust: exact!important;print-color-adjust:exact !important;}}@page{margin: 5px;padding: 5px;}*, *::before, *::after{box-sizing: border-box;}body{font-family: "Roboto", sans-serif;color:#526484;}.card {position: relative;display: flex;flex-direction: column;min-width: 0;word-wrap: break-word;background-color: #fff;background-clip: border-box;border: 0 solid rgba(0, 0, 0, 0.125);border-radius: 4px;}.card-inner {padding: 0.5rem;}table{caption-side: bottom;border-collapse: collapse;}thead,tbody,tfoot,tr,td,th{border-color: inherit;border-style: solid;border-width: 0;}.logo-img{max-height: 36px;}img{max-width: 100%;}img,svg{vertical-align: middle;}.text-center{text-align: center;}.overflow-hidden{overflow: hidden;}.text-white{color:#fff;}h2,h3,h6{padding:0;margin:0 0 0.5rem 0;letter-spacing: -0.03em;font-weight: 700;line-height: 1.1;}.mb-0{margin-bottom: 0;}.d-block{display: block;}a{transition: color 0.4s, background-color 0.4s, border 0.4s, box-shadow 0.4s;text-decoration: none;touch-action: manipulation;outline: none;background-color: transparent;cursor: pointer;}.w-100{width: 100%;}.text-end{text-align: right;}.invoiceTableContent{padding-right: 0px;}.pe-0{padding-right: 0;}.mt-2{margin-top: 0.75rem;}.mt-1{margin-top: 0.375rem}p{padding:0;margin:0;}b,strong{font-weight: bolder;}.btn{position: relative;letter-spacing: 0.02em;display: inline-flex;align-items: center;font-weight: 700;line-height: 1.25rem;text-align: center;vertical-align: middle;cursor: pointer;-webkit-user-select: none;user-select: none;background-color: transparent;border: 1px solid transparent;padding: 0.4375rem 1.125rem;font-size: 0.8125rem;border-radius: 4px;}.linkButton{color: #F47721;cursor: pointer;}.btn-primary{color: #fff;background-color: #F47721;border-color: #F47721;}.btn-secondary{color: #fff;background-color: #364a63;border-color: #364a63;}.pt-3{padding-top: 1rem;}.ms-2{margin-left: 0.75rem;}.ms-2{margin-left: 0.75rem;}.mt-3{margin-top: 1rem;}.ni-info::before{content:"ⓘ";}.ni-info{color:#131313;}em.ni-info{font-style: normal;}.ni-info{font-size:11px; margin-left: 5px;color: #F47721;display:inline-block;}</style>'
    // );
    winPrint.document.write(
      '<html><head>' +
        '<link rel="preconnect" href="https://fonts.googleapis.com">' +
        '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>' +
        '<link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet">' +
        '<style>' +
        '@media print { body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; } }' +
        // Add your other styles for printing here
        `.visible-note { display: none} .hide-note {
          display: block;
        }` +
        '</style>' +
        '</head><body>'
    );
  } else {
    winPrint.document.write(
      '<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Outfit:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet"><style>@media print{body{-webkit-print-color-adjust: exact!important;print-color-adjust:exact !important;}}@page{margin: 5px;padding: 5px;}*, *::before, *::after{box-sizing: border-box;}body{font-family:"Outfit", sans-serif;}.mt-2{ margin-top: 0.5rem!important;}.text-center{text-align:center;} p{margin-top:0px ;}.note P { color: #909090; font-size: 13px; line-height: 17px; margin-bottom:0px; }.ratingPage_profile_content ul { color: #131313;font-size: 14px;line-height: 19px;}.ratingPage_Box{border-radius: 10px; padding:30px; background-color:#fff;}.ratingPage_profile{background-color: #ffedde;border: 1px solid #f77708;border-radius: 5px;padding: 32px; margin-bottom:24px;}.ratingPage_profile_content{text-align:center; }.ratingPage_profile_content img{border-radius: 50%;height: 106px;width: 106px;}.ratingPage_profile_content h2{color: #000;font-weight: 600;font-size: 18px;line-height: 24px;margin-top: 10px; margin-bottom: 0px;}.ratingPage_profile_content p{color: #131313;font-size: 14px;line-height: 19px;margin-top: 10px; margin-bottom: 0px;}.ratingPage_profile_content ul{ padding-left:0px; margin-top: 4px; display: flex; justify-content:center; margin-bottom:0px; list-style: none;}[data-star] {display: inline-block;font-size: 18px;font-style: normal;letter-spacing: 4px;position: relative;text-align: left;unicode-bidi: bidi-override;}[data-star]::before {color: rgb(213, 213, 213);content: "★★★★★";display: block;}[data-star]::after {color: rgb(247, 119, 8);content: "★★★★★";height: 100%;left: 0px;position: absolute;top: 0px;white-space-collapse: collapse;text-wrap: nowrap;width: 0px; overflow: hidden; }[data-star^="4.9"]:after { width: 98%; }[data-star^="3.5"]:after { width: 70%; }.ratingPage_Payment {border: 1px solid #d6d6d678; border-radius: 5px; padding: 20px 16px;}.ratingPage_Services { padding: 0; border-bottom: 1px solid #d6d6d678;}.ratingsubhead { font-size: 14px; line-height: 19px; padding-right: 10px; margin-top:0px; }.ratingheading, .ratingsubhead{color: #131313; font-weight: 600;}p.ratingamount, p.ratingpara{font-size: 14px;}.ratingamount, .ratingpara { color: #909090; font-size: 12px; line-height: 16px; }.ratingPage_Services { padding-bottom: 17px; }.ant-checkbox-group { box-sizing: border-box; margin: 0; padding: 0; color: rgba(0,0,0,.85); font-size: 14px; font-variant: tabular-nums; line-height: 1.5715; list-style: none; font-feature-settings: "tnum"; display: inline-block; width: 100%; }.ratingPage_Services_inner {margin: 10px 0px;overflow-x: auto;overflow-y: hidden; justify-content: space-between; display: flex;}.ratingPage_Services_inner img {border-radius: 5px;flex-shrink: 0;height: 45px;width: 45px;margin-right: 0.5rem; object-fit:cover;}.ratingPage_desc {max-width: 430px;width: 100%;}.ratingPage_Services_image {height: 140px;margin: 5px 0 30px;max-width: 100%;}.ratingPage_Services_image{border: 1px solid #70707033;border-radius: 5px;height: 110px;margin: 10px 0 20px; width: 100%;padding: 10px;text-align: center;}.ratingPage_Services_image img {height: 100%;object-fit: contain;width: 100%;}.mt-3{margin-top: 16px; }.ratingheading {font-size: 16px;line-height: 17px;}.note {border: 1px solid #70707033;min-height: 110px;padding: 15px;}.quote {border-radius: 5px;margin: 17px 0 0;text-align:center;}.quote span {color: #909090;}.ratingPage_Services {padding: 17px 0;}.btn-primary {background-color: #f77708;border-color: #f77708;color: #fff;}.btn-lg {font-size: 16px;height: 52px;}.btn {align-items: center;border-radius: 5px;display: flex;font-weight: 600;justify-content: center;padding: 8px 12px;text-transform: uppercase; justify-content: center!important; border:none; }.min-170 {min-width: 170px;}.font-sm {font-weight: 700;}.d-flex{display: flex;}.justify-content-end{justify-content: flex-end!important;}.justify-content-between{justify-content: space-between;}.align-items-center{align-items: center;}.mt-sm-4 {margin-top: 1.5rem!important;}.pt-0{padding-top: 0px !important;}.mb-0{margin-bottom: 0px !important;}.mb-1{margin-bottom: 4px !important;}.border-bottom-0{border-bottom: 0px !important;}.p-0{padding: 0px !important;}.mb-2 {margin-bottom: 0.5rem!important;} .btn-light {background-color: #f0f2f9; border-color: #f0f2f9; color: #717171;}.me-2 {margin-right: 0.5rem!important;}.ratingPage .ant-checkbox-wrapper {padding-right: 10px;}.ant-checkbox-wrapper {box-sizing: border-box;margin: 0;padding: 0;color: rgba(0,0,0,.85);font-size: 14px;font-variant: tabular-nums;line-height: 1.5715;list-style: none;font-feature-settings: "tnum";display: inline-flex;align-items: baseline;line-height: unset;cursor: pointer;}.ant-checkbox {box-sizing: border-box;margin: 0;padding: 0;color: rgba(0,0,0,.85);font-size: 14px;font-variant: tabular-nums;line-height: 1.5715;list-style: none;font-feature-settings: "tnum";position: relative;top: 0.2em;line-height: 1;white-space: nowrap;outline: none;cursor: pointer;}.ant-checkbox-input {position: absolute;top: 0;right: 0;bottom: 0;left: 0;z-index: 1;width: 100%;height: 100%;cursor: pointer;opacity: 0;}.ant-checkbox-inner {position: relative;top: 0;left: 0;display: block;width: 16px;height: 16px;direction: ltr;background-color: #fff;border: 1px solid #d9d9d9;border-radius: 2px;border-collapse: separate;transition: all .3s;}.ant-checkbox-wrapper .ant-checkbox-inner:after {left: 20%;}.ant-checkbox-inner:after {position: absolute;top: 50%;left: 21.5%;display: table;width: 5.71428571px;height: 9.14285714px;border: 2px solid #fff;border-top: 0;border-left: 0;transform: rotate(45deg) scale(0) translate(-50%,-50%);opacity: 0;transition: all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s;content: " ";}.ant-checkbox-wrapper:after {display: inline-block;width: 0;overflow: hidden;content: "a0";}.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner { background-color: #f77708; border-color: #f77708; }.ant-checkbox-wrapper .ant-checkbox-inner {border-color: #f77708;border-width: 1px;}.ant-checkbox-checked .ant-checkbox-inner:after {position: absolute;display: table;border: 2px solid #fff;border-top: 0;border-left: 0;transform:rotate(45deg) scale(1) translate(-50%,-50%);opacity: 1;transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s;content: " ";}.ant-checkbox-wrapper .ant-checkbox-checked:after {border-color: #f77708;}.ant-checkbox-wrapper {padding-right: 10px;}.gg-danger-circle::before{content:"ⓘ";}.gg-danger-circle{color:#131313;}em{font-style: normal;}a{text-decoration:none;}.ratingPage_desc a{display: flex;transform: rotate(180deg);}.gg-danger-circle{font-size:11px; margin-left: 5px;}[data-star^=".1"]::after,[data-star^="0.1"]::after{width:2%}[data-star^=".2"]::after,[data-star^="0.2"]::after{width:4%}[data-star^=".3"]::after,[data-star^="0.3"]::after{width:6%}[data-star^=".4"]::after,[data-star^="0.4"]::after{width:8%}[data-star^=".5"]::after,[data-star^="0.5"]::after{width:10%}[data-star^=".6"]::after,[data-star^="0.6"]::after{width:12%}[data-star^=".7"]::after,[data-star^="0.7"]::after{width:14%}[data-star^=".8"]::after,[data-star^="0.8"]::after{width:16%}[data-star^=".9"]::after,[data-star^="0.9"]::after{width:18%}[data-star^="1"]::after{width:20%}[data-star^="1.1"]::after{width:22%}[data-star^="1.2"]::after{width:24%}[data-star^="1.3"]::after{width:26%}[data-star^="1.4"]::after{width:28%}[data-star^="1.5"]::after{width:30%}[data-star^="1.6"]::after{width:32%}[data-star^="1.7"]::after{width:34%}[data-star^="1.8"]::after{width:36%}[data-star^="1.9"]::after{width:38%}[data-star^="2"]::after{width:40%}[data-star^="2.1"]::after{width:42%}[data-star^="2.2"]::after{width:44%}[data-star^="2.3"]::after{width:46%}[data-star^="2.4"]::after{width:48%}[data-star^="2.5"]::after{width:50%}[data-star^="2.6"]::after{width:52%}[data-star^="2.7"]::after{width:54%}[data-star^="2.8"]::after{width:56%}[data-star^="2.9"]::after{width:58%}[data-star^="3"]::after{width:60%}[data-star^="3.1"]::after{width:62%}[data-star^="3.2"]::after{width:64%}[data-star^="3.3"]::after{width:66%}[data-star^="3.4"]::after{width:68%}[data-star^="3.5"]::after{width:70%}[data-star^="3.6"]::after{width:72%}[data-star^="3.7"]::after{width:74%}[data-star^="3.8"]::after{width:76%}[data-star^="3.9"]::after{width:78%}[data-star^="4"]::after{width:80%}[data-star^="4.1"]::after{width:82%}[data-star^="4.2"]::after{width:84%}[data-star^="4.3"]::after{width:86%}[data-star^="4.4"]::after{width:88%}[data-star^="4.5"]::after{width:90%}[data-star^="4.6"]::after{width:92%}[data-star^="4.7"]::after{width:94%}[data-star^="4.8"]::after{width:96%}[data-star^="4.9"]::after{width:98%}[data-star^="5"]::after{width:100%}</style>'
    );
  }
  winPrint.document.write('</head><body>');
  winPrint.document.write(printContents);
  winPrint.document.write('</body></html>');
  winPrint.document.close();
  winPrint.focus();
  winPrint.print();
  winPrint.close();
};

export const checkNumberAndPercentage = (value, valueP) => {
  if (value && valueP > 0) {
    return `${value} (${valueP}%)`;
  } else {
    return value;
  }
};

export const capitalizeStringFirstLetter = (string) => {
  let result = '';
  const splitString = string?.split?.(' ');

  splitString?.forEach?.((stritem) => {
    result = result + ` ${capitalizeFirstLetter?.(stritem)}`;
  });

  return result?.trim?.();
};

export const convertSlotFormat = (slotLists = []) => {
  let results = [];
  if (slotLists.length > 0)
    results = slotLists?.map?.((slotListItem) => {
      const splitSlot = slotListItem?.slotTime?.split?.(/[-:/]/);
      if (
        parseInt(splitSlot?.[0] ?? 0) >= 13 ||
        parseInt(splitSlot?.[2] ?? 0) >= 13
      ) {
        let temp = splitSlot;

        if (parseInt(splitSlot?.[0] ?? 0) >= 13) {
          if (temp?.[0]) temp[0] = (parseInt(temp?.[0]) % 12)?.toString?.();
        }
        if (parseInt(splitSlot?.[2] ?? 0) >= 13) {
          if (temp?.[2]) temp[2] = (parseInt(temp?.[2]) % 12)?.toString?.();
        }

        const startTime = `${splitSlot[0]}:${splitSlot[1]}`;
        const endTime = `${splitSlot[2]}:${splitSlot[3]}`;

        const timeRange = `${startTime}-${endTime}`;

        return {
          ...slotListItem,
          value: slotListItem?.slotTime,
          slotTime: timeRange,
        };
      } else {
        return {
          ...slotListItem,
          value: slotListItem?.slotTime,
        };
      }
    });

  return results;
};

export const convertMinDotSecToMinutes = (minutes) => {
  const splitTime = minutes?.split?.('.');
  const convertIntoMinutes =
    parseInt(splitTime?.[0] ?? 0) + (parseInt(splitTime?.[1] ?? 0) % 3600) / 60;
  return convertIntoMinutes;
};

export const minuteIntoHHMMSS = (minutes) => {
  if (minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const seconds = Math.round(
      (remainingMinutes - Math.floor(remainingMinutes)) * 60
    );
    const time = `${hours}h ${Math.floor(remainingMinutes)}m ${seconds}s`;
    return time;
  }
};

function convertTo12Hour(time) {
  const [hour, minute] = time.split(':');

  const period = hour >= 12 ? 'PM' : 'AM';
  const twelveHour = hour % 12 || 12;
  return `${twelveHour}:${minute} ${period}`;
}

export const convertTo12HourFormat = (timeRange) => {
  const times = timeRange.split('-');
  const startTime12Hour = convertTo12Hour(
    typeof times[0] === 'string' ? times[0].replace(/AM|PM/gi, '') : ''
  );
  const endTime12Hour = convertTo12Hour(
    typeof times[1] === 'string' ? times[1].replace(/AM|PM/gi, '') : ''
  );
  return `${startTime12Hour} - ${endTime12Hour}`;
};

export const debounce = (func, delay) => {
  let timerId;

  return function () {
    const context = this;
    const args = arguments;

    clearTimeout(timerId);

    timerId = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
};

export const checkSelectData = async ({
  key,
  listApi,
  query,
  type = 'single',
}) => {
  try {
    if (key && listApi) {
      const res = Array.isArray(listApi) ? listApi : await listApi(query);
      if (res) {
        const value =
          res?.length &&
          res.map((e) => e?.id)?.length &&
          res
            .map((e) => e?.id)
            .filter((id) => {
              return Array.isArray(key) && key?.length
                ? key?.includes(id)
                : id === key;
            });

        return type === 'single' ? value[0] : value;
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export function copyToClipBoard(text) {
  try {
    window.navigator.clipboard.writeText(text);
    modalNotification({
      type: 'info',
      message: 'Copied',
    });
  } catch (e) {
    console.log(e);
  }
}

export const getDayDifference = (firstDate, lastDate) => {
  return Math.abs(firstDate.diff(lastDate, 'days'));
};

export const columnVisibilityOptions = (columns, columnHandler) => {
  const options = columns.map((item) => ({
    handler: columnHandler,
    title: item?.showNameInCheckbox ? item?.showNameInCheckbox : item?.title,
    isHidden: item?.isHidden,
    label: item?.showNameInCheckbox ? item?.showNameInCheckbox : item?.title,
    value: item.dataIndex
      ? item.dataIndex
      : item?.filterDataIndex
        ? item?.filterDataIndex && item?.filterDataIndex[0]
        : item?.dataField.split('.').pop(),
  }));
  const hasHidden = options.some(item => item.isHidden === true);

  options.unshift({
    handler: columnHandler,
    title: 'Select All',
    isHidden: hasHidden,
    label: 'Select All',
    value: 'checkedAll',
  });

  return options;
}

export const handleBeforeUnload = (e) => {
  e.preventDefault();
  e.returnValue = "";
}
